import { Field, FieldLabelProps, Switch as SwitchChakra } from '@chakra-ui/react';

import { SwitchComponentProps } from './switch.props';

interface baseLabelProps extends FieldLabelProps {
    label: string;
    'data-testid'?: string;
}

export const Switch = ({
    id,
    labelLeft,
    labelRight,
    labelProps,
    name,
    checked,
    onChange,
    ...props
}: SwitchComponentProps): JSX.Element => {
    const BaseLabel = ({ label, textAlign, fontWeight, ...rest }: baseLabelProps) => (
        <Field.Label
            {...labelProps}
            htmlFor={id}
            m={0}
            fontSize={'sm'}
            textAlign={textAlign}
            fontWeight={fontWeight}
            {...rest}
        >
            {label}
        </Field.Label>
    );

    return (
        <Field.Root display="flex" alignItems="center" gap={2} data-testid={'switch-wrapper'}>
            {labelLeft && (
                <BaseLabel
                    data-testid={'switch-left-label'}
                    label={labelLeft}
                    textAlign={'end'}
                    fontWeight={!checked ? 'bold' : 'normal'}
                />
            )}
            <SwitchChakra.Root
                size="lg"
                id={id}
                name={name}
                onChange={onChange}
                checked={checked}
                {...props}
            >
                <SwitchChakra.HiddenInput />
                <SwitchChakra.Control>
                    <SwitchChakra.Thumb />
                </SwitchChakra.Control>
                <SwitchChakra.Label asChild>
                    <BaseLabel
                        data-testid={'switch-label'}
                        label={labelRight}
                        fontWeight={checked ? 'bold' : 'normal'}
                    />
                </SwitchChakra.Label>
            </SwitchChakra.Root>
        </Field.Root>
    );
};
